import React, { FC } from "react";
import { faGithub, faGitlab } from "@fortawesome/free-brands-svg-icons";

import { ScmType } from "@protos/common/v1/common";
import { useBasePath, useSupportsFeature } from "@shared/hooks";

import {
  SetupProjectChooseType,
  SMSProjectTypeOption,
} from "./SetupProjectChooseType";

const OPTIONS: SMSProjectTypeOption[] = [
  {
    scmType: ScmType.GITHUB,
    title: "GitHub",
    faIcon: faGithub,
  },
  {
    scmType: ScmType.GITLAB,
    title: "GitLab",
    faIcon: faGitlab,
  },
];

interface SetupProjectChooseSMSTypeProps {
  onClose?: () => void;
}

export const SetupProjectChooseSMSType: FC<SetupProjectChooseSMSTypeProps> = ({
  onClose,
}) => {
  const basePath = useBasePath();
  const hasUpdatedSCMOnboarding = useSupportsFeature("hasUpdatedSCMOnboarding");

  const getNextLink = (option: SMSProjectTypeOption) => {
    // If the feature flag is on, we should redirect to the managed setup page
    // TODO: Remove the feature flag and the code in the else block once the feature is fully rolled out
    if (hasUpdatedSCMOnboarding) {
      let path;
      if (option.scmType === ScmType.GITHUB) {
        path = `${basePath}/setup/managed/github`;
      } else {
        path = `${basePath}/setup/managed/gitlab`;
      }
      onClose?.();
      return path;
    } else {
      if (option.scmType === ScmType.GITHUB) {
        return `${basePath}/setup/managed`;
      } else {
        return `${basePath}/settings/source-code`;
      }
    }
  };

  return (
    <SetupProjectChooseType
      title="Scan new project with Semgrep Managed Scans"
      options={OPTIONS}
      getNextLink={getNextLink}
    />
  );
};
